import React from 'react'
import { IonContent, IonPage } from '@ionic/react'
import PageHeader from '../../components/PageHeader'

const ChatPage: React.FC = () => {
  return (
    <IonPage>
      <PageHeader title="Chat" />
      <IonContent className="ion-padding">
        <h1 className="hidden sm:block text-2xl font-heading font-bold text-gray-900 mb-4">AI Coach Chat</h1>
        <p>Chat with your AI coaching assistant here.</p>
      </IonContent>
    </IonPage>
  )
}

export default ChatPage 